export default "__VITE_ASSET__iXd6MC6R__"